import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { AuthClient } from 'app/auth/auth.client';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from 'app/shared/services/overlay.service';
import { HttpXsrfTokenExtractor } from "@angular/common/http";
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';


@Component({
    selector: 'adminlogin',
    templateUrl: 'admin-login.component.html',
    styleUrls: ['admin-login.component.scss']
})
export class AdminLoginComponent {
    public userName = '';
    public password = '';
    public rememberMe: boolean;

    constructor(private _router: Router,
        private _autoLoginClient: AutoLoginClient,
        private _authClient: AuthClient,
        private _translateService: TranslateService,
        private _overlayService: OverlayService,
        private _tokenExtractor: HttpXsrfTokenExtractor,
        private _i18nService: I18nService,
        private _showToastService: ShowToastService) { }

    ngAfterViewInit() {
      this._overlayService.hide();
    }

    public login() {
        const XSRFtoken = this._tokenExtractor.getToken() as string;
        $.ajaxSetup({
            beforeSend(xhr) {
                xhr.setRequestHeader('X-XSRF-TOKEN', XSRFtoken);
            }
        });
        if (this.userName.length > 0 && this.password.length > 0) {
            this._autoLoginClient.login(this.userName, this.password).subscribe((data: any) => {
                switch (data.autoLoginCodeMessage) {
                    case 'LoginUserMustChangePassword':
                        this._router.navigate(['email-sent']);
                        break;
                    case 'LoginSucessful':
                        sessionStorage.setItem('timeExpiration', data.sessionTimeout);
                        this._authClient.setAuthenticationSubject(true);
                        this._router.navigate(['mc']);
                        break;
                    case 'LoginUserNotVerified':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.USER_NOT_VERIFIED'), 'error');
                        break;
                    case 'LoginUserInactive':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.USER_INACTIVE'), 'error');
                        break;
                    case "LoginLockedAccount":
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.LOCKED_ACCOUNT'), 'error');
                        break;           
                    case 'LoginWrongCredentials':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.WRONG_CREDENTIALS'), 'error');
                        break;
                    case 'SendVerificationCodeUnexpectedError':
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR'), 'error');
                        break;
                    case 'LoginUnexpectedError':
                        this._showToastService.showToast(this._i18nService.instant('GLOBAL.GENERIC_ERROR_MSG'), 'error');
                        break;

                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._showToastService.showToast(this._i18nService.instant('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION'), 'error');
                        break;

                    default:
                        break;
                }

            });
        }
    }


    public restorePassword() {
        this._router.navigate(['send-password-email']);
    }
}
